import { connect } from 'react-redux'
import at from 'lodash/at'

import ServiceSummaries from '../../components/service-summaries/service-summaries'
import countServicesInSummaries from '../../helpers/count-services-in-summaries'

import { fetchServiceSummariesForWorkOrder } from '../../actions/service-summaries'
import { fetchWorkAreaSummariesForWorkOrder } from '../../actions/work-area-summaries'
import { countByAreaTypesSelector } from '../../selectors/work-summary-selectors';

function mapStateToProps (state, ownProps) {
  const workOrder = state.workOrders[ownProps.workOrderId]
  const serviceSummaries = at(state.serviceSummaries, workOrder.serviceSummaries || [])

  return {
    workOrder,
    summariesWithCounts: countServicesInSummaries(serviceSummaries),
    areaTypeAreaCount: countByAreaTypesSelector(state, ownProps)
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServiceSummariesForWorkOrder(ownProps.workOrderId))
    .then(() => dispatch(fetchWorkAreaSummariesForWorkOrder(ownProps.workOrderId)))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceSummaries)



// WEBPACK FOOTER //
// ./src/containers/service-summaries/service-summaries-container.js